import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

const useStyles = (startBreakpoint: Breakpoint) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      overlay: {
        height: '100%',
        width: 0,
        position: 'fixed',
        zIndex: 1200,
        top: 0,
        right: 0,
        overflowX: 'hidden',
        transition: '0.5s',
        background: theme.palette.secondary.dark,
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up(startBreakpoint)]: {
          display: 'none',
        },
      },
      overlayOpened: {
        width: '100%',
        padding: 24,
        [theme.breakpoints.up('sm')]: {
          padding: 30,
        },
      },
      contentWrapper: {
        position: 'relative',
        width: '100%',
        marginTop: 75,
        flex: 1,
      },
      overlayLogoWrapper: {
        display: 'flex',
        height: 45,
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
          height: 60,
        },
        '& img': {
          height: '100%',
        },
      },
      overlayCloseIcon: {
        fontSize: 32,
        position: 'absolute',
        top: 24,
        right: 24,
        width: 21,
        height: 21,
        cursor: 'pointer',
      },
    });
  });

export default useStyles;
